<template>
  <div>
    <div id="gosee-nav">
      <span class="gosee-exit" v-on:click="backToHome()"
        >&lt;&nbsp;&nbsp;返回</span
      >
      <img src="@/assets/images/history-title.png" class="result-title" />
      <div class="hitory-tishi">
        <div class="history-call" v-on:click="linkToService()">
          <span>客服</span>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <img
      src="@/assets/images/bgTitle.png"
      style="width: 100%;vertical-align: top;height: 18px;"
    />
    <div id="history-product" v-if="isNotEmpty">
      <ul>
        <li v-for="(item, index) in paidHistory" :key="index">
          <div class="history-message" v-on:click="linkToResult(item.orderNo)">
            <span class="history-date"
              >占卜时间：{{
                item.quizTime
                  | moment('timezone', 'America/Los_Angeles', 'YYYY-MM-DD')
              }}</span
            >
            <span class="history-name"
              >被测姓名：{{ item.firstname }}{{ item.lastname }}</span
            >
            <span class="history-this-next">></span>
            <img src="@/assets/images/text1.png" />
          </div>
        </li>
      </ul>
    </div>
    <div class="hasHistory" v-if="!isNotEmpty">
      <p class="hasHistoryOne">还没有历史记录哦～</p>
      <p class="hasHistoryTwo">进行占卜后可获得占卜记录。</p>
    </div>
    <div class="line-scale" v-show="isLoading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import { mapState, mapGetters } from 'vuex'
import { FORTUNE_GETTERS } from '../store/modules/fortune-getters-types'

Vue.use(VueMoment, {
  moment
})

export default {
  name: 'History',
  mounted: function() {
    try {
      TtxTrack.track('xing-ming-v2', 'FORTUNE_HISTORY')
    } catch (e) {
      // console.log(e)
    }
  },
  methods: {
    backToHome: function() {
      this.$router.push({ name: 'Home' })
    },
    linkToService: function() {
      this.$router.push({ name: 'Service' })
    },
    linkToResult: function(orderNo) {
      this.$router.push({ name: 'Result', params: { orderNo } })
    }
  },
  computed: {
    ...mapState({
      history: state => state.fortune.history
    }),
    ...mapGetters('fortune', {
      isNotEmpty: FORTUNE_GETTERS.IS_NOT_EMPTY,
      isLoading: FORTUNE_GETTERS.IS_LOADING
    }),
    paidHistory: function() {
      return this.history.filter(function(item) {
        return item.paid === true
      })
    }
  }
}
</script>
<style scoped>
.history-call {
  background: url('../assets/images/call.png');
  float: right;
}
.history-call,
.history-qes {
  background-position: 0 0;
  background-size: 100%;
  background-repeat: no-repeat;
  width: 26px;
  height: 26px;
  margin-left: 2%;
  text-align: center;
}
</style>
